import { t } from "i18next";
import { FaUserGroup } from "react-icons/fa6";
import { Tooltip } from "react-tooltip";

import { GuestMinMaxBadgeProps } from "@models/shared/shared.model";

const GuestMinMaxBadge = ({ allowBringGuest, slot }: GuestMinMaxBadgeProps) => {
  if (!allowBringGuest || !slot || (!slot.min && !slot.max)) return null;

  const badgeText =
    slot.min && slot.max
      ? t("addGuest.minMaxBadge", { max: slot.max, min: slot.min })
      : slot.min
        ? t("addGuest.minBadge", { min: slot.min })
        : t("addGuest.maxBadge", { max: slot.max });

  const tooltipText =
    slot.min && slot.max
      ? t("addGuest.minMaxTooltip", { max: slot.max, min: slot.min })
      : slot.min
        ? t("addGuest.minTooltip", { min: slot.min })
        : t("addGuest.maxTooltip", { max: slot.max });

  return (
    <>
      <small
        className="fg-booking-min-max-badge ms-2"
        data-tooltip-id="fg-booking-min-max-badge-tooltip"
      >
        <FaUserGroup /> {badgeText}
      </small>

      <Tooltip
        id="fg-booking-min-max-badge-tooltip"
        className="fg-booking-min-max-badge-tooltip"
        place="top"
      >
        {tooltipText}
      </Tooltip>
    </>
  );
};

export default GuestMinMaxBadge;
